export default __webpack_public_path__ + "static/media/accept-crypto.f21a1e40.png";